import { ErrorPage } from '@/pages/Layout/pages';
import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import { lazy } from 'react';
import {
  BUSINESS_ROLE_GROUPS,
  EXTERNAL_OPERATOR_ROLE_GROUPS,
} from '@/components/security/AppRoles';

const Branches = lazy(() => import('../Branches'));
const ViewBranch = lazy(() => import('../pages/ViewBranch'));
const EditBranch = lazy(() => import('../pages/EditBranch'));
const CreateBranch = lazy(() => import('../pages/CreateBranch'));

const ADMIN_PERMISSIONS = [
  ...BUSINESS_ROLE_GROUPS.operations,
  ...EXTERNAL_OPERATOR_ROLE_GROUPS.admin,
];

const BranchesRoutes: RouteObject[] = [
  {
    path: 'logistics-management/commerce/:commerceId/branches',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <Branches />
      </Authorize>
    ),
  },
  {
    path: 'logistics-management/commerce/:commerceId/branches/:branchId',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <ViewBranch />
      </Authorize>
    ),
  },
  {
    path: 'logistics-management/commerce/:commerceId/branches/:branchId/edit',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <EditBranch />
      </Authorize>
    ),
  },
  {
    path: 'logistics-management/commerce/:commerceId/branches/create',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <CreateBranch />
      </Authorize>
    ),
  },
];

export default BranchesRoutes;
